import { useEffect } from 'react'
import { QSortV2Params } from '../../../parameters/types'
import { useCommonCtx } from '../../../context/useCommonCtx'
import { useTranslation } from '../../../i18n/useTranslation'
import { useBinsStore } from '../lib/state'
import { BinsStore } from '../lib/types'
import { TranslatorFn } from '../../../i18n/useTranslation'
import { validateBinState } from '../lib/helper'
import { TKeys } from '../../../i18n/types'

export const checkWarningEvents = (
    binStoreObj: BinsStore,
    t: TranslatorFn): void => {
    console.debug('>>> checkWarningEvents recompute start')
    const {
        // state:
        bins,
        selectedBinRef,
        // actions:
        updateWarningProps,
        setHasNextBtn,
    } = binStoreObj

    const {
        isToAssign,
        exceedingBinRefs,
        selectedIsExceeding,
        selectedIsInsufficient,
        selectedIsEmpty,
        allAssignedExceeding,
        sortingIsDone, // all assigned, no exceeding, no insufficient
    } = validateBinState(bins, selectedBinRef)

    setHasNextBtn(sortingIsDone)

    if (selectedIsExceeding) {
        updateWarningProps({
            title: t('too_much_warning')
        })
    } else if (selectedIsEmpty) {
        updateWarningProps({
            title: t('empty_bin')
        })
    } else if (selectedIsInsufficient) {
        updateWarningProps({
            title: t('too_insufficient_warning')
        })
    } else if (isToAssign && allAssignedExceeding) {
        updateWarningProps({
            title: `${t('too_much_warning1')} ${exceedingBinRefs
                .map((ref) => t(ref as TKeys))
                .join(', ')}`,
            subtitle: t('too_much_warning2'),
        })
    } else {
        updateWarningProps(null)
    }
    console.debug('>>> checkWarningEvents recomputed')
}


export const useWarningEvents = (
) => {
    const commons = useCommonCtx()
    const t = useTranslation(commons)
    const binStoreObj = useBinsStore()

    useEffect(() => {
        console.debug('>>> useWarningEvents recompute checkWarningEvents')
        checkWarningEvents(
            binStoreObj,
            t,
        )
    }, [
        // Only include the dependencies that should trigger a recalculation
        binStoreObj.bins,
        binStoreObj.selectedBinRef,
        t,
    ])
}
